import React, { RefObject } from 'react';
import { Link } from 'gatsby';

import { getBaseUrlByCategory, getLanguagePrefix, renderWhenTrue } from '../../utils';
import { SectionContainer, ContentWidth, ExternalLink } from '../../uiComponents';
import { LanguageSlug } from '../../enums/languageSlug.enum';

import {
  CaseStudyBox,
  Photo,
  LabelContainer,
  CountryLabel,
  Label,
  ArrowIcon,
  PhotoContainer,
  PhotoBackground,
} from './caseStudySection.styled';
import Arrow from './images/arrow.svg';
import { CaseStudySectionData, CaseStudyData } from './caseStudySection.types';
import { PageCategory } from '../../enums/pageCategory.enum';
import { BasePath } from '../../interfaces/basePath.types';

export const CaseStudySection = React.forwardRef<HTMLAnchorElement, CaseStudySectionData>((data: CaseStudySectionData, ref: RefObject<HTMLAnchorElement>) => {
  const {
    header,
    caseStudyBoxes,
    className,
    labelBackgroundColor,
    boxesBaseUrl,
    currentLanguage,
    highlightedCaseStudyTitle,
    basePaths,
  } = data;

  const getBasePath = (projectName: string) => {
    const item = basePaths.find((item: BasePath) => {
      if (item.language === currentLanguage && item.project === projectName) {
        return item;
      };
    });
    return item;
  };

  const renderBoxes = renderWhenTrue(() => caseStudyBoxes.map((box: CaseStudyData) => {
    const renderPhoto = renderWhenTrue(() => (<Photo src={box.acf.image?.localFile?.url} />));
    const projectUrl = getBaseUrlByCategory(box.categories);
    const basePath = getBasePath(box.categories[0].name.toLowerCase());
    const isCurrentProjectLink = basePath.slug === boxesBaseUrl && process.env.PROJECT_CATEGORY !== PageCategory.MainPage;
    
    const getLinkBoxUrl = (url: string) => {
      const slash = isCurrentProjectLink ? '/' : '';
      const path = `${projectUrl}${slash}${getLanguagePrefix(currentLanguage)}${basePath.slug}`;
      return `${path}/${url}`
    };
    
    const boxRef = highlightedCaseStudyTitle === box.post_title ? ref : null;

    const renderBox = () => (
      <CaseStudyBox ref={boxRef}>
        <PhotoContainer>
          {renderPhoto(!!box.acf.image)}
          <PhotoBackground />
        </PhotoContainer>
        <LabelContainer backgroundColor={labelBackgroundColor}>
          <CountryLabel>{box.acf.country}</CountryLabel>
          <Label>{box.post_title}</Label>
          <ArrowIcon src={Arrow} alt='arrow' />
        </LabelContainer>
      </CaseStudyBox>
    );

    return !projectUrl ? (
      <Link to={getLinkBoxUrl(box.post_name)} key={box.post_title}>
        {renderBox()}
      </Link>
    ) : (
      <ExternalLink href={getLinkBoxUrl(box.post_name)} key={box.post_title}>
        {renderBox()}
      </ExternalLink>
    );
  }));

  return (
    <SectionContainer
      isGridModeEnable
      header={header}
      className={className}
      contentWithMode={ContentWidth.FullWidth}
    >
      {renderBoxes(!!caseStudyBoxes && !!caseStudyBoxes.length)}
    </SectionContainer>
  );
});
